import React from 'react';

function HeroSection({ handleScroll }) {
  return (
    <section className="relative flex items-center justify-center min-h-screen z-10 select-none text-gray-800 mb-80">
      {/* 背景動画 */}

      {/* コンテンツ */}
      <div className="relative z-10 flex flex-col lg:flex-row items-center justify-center gap-12 px-6">
        {/* ロゴ画像 */}
        <div className="flex-shrink-0 mt-[-12rem] sm:mt-0">
          <img
            src="/image/Chaln_black.png"
            alt="Chaln.inc ロゴ"
            className="w-80 h-80 md:w-[400px] md:h-[400px] object-contain drop-shadow-2xl animate-fade-in-up"
            style={{ animationDelay: '0.1s' }}
          />
        </div>

        {/* キャッチコピー */}
        <div className="text-center max-w-lg mt-[-3rem] sm:mt-0">
          <h1 className="text-4xl md:text-5xl font-extrabold tracking-wide leading-tight md:whitespace-nowrap">
            <div className="flex flex-col lg:inline">
              <span className="text-orange-500 inline-block animate-fade-in-up" style={{ animationDelay: '1.2s' }}>
                Challenge
              </span>
              <span className="hidden lg:inline">{' '}</span>
              <span className="inline-block">
                ×
              </span>
              <span className="hidden lg:inline">{' '}</span>
              <span className="text-black inline-block animate-fade-in-up" style={{ animationDelay: '2.0s' }}>
                Innovation
              </span>
            </div>
          </h1>
          <p className="mt-8 text-lg md:text-2xl font-medium text-gray-700 animate-fade-in-up" style={{ animationDelay: '2.7s' }}>
            挑戦と革新で明日を創造する。<br />
            あなたの描いた未来はここにある。<br />
          </p>
        </div>
      </div>
      {/* カスタムアニメーションCSS */}
      <style>{`
        @keyframes fade-in-up {
          0% {
            opacity: 0;
            transform: translateY(40px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fade-in-up {
          animation: fade-in-up 1s cubic-bezier(0.4,0,0.2,1) both;
        }
        @keyframes fade-in-scale {
          0% {
          opacity: 0;
          transform: scale(0.7);
          }
          60% {
            opacity: 1;
            transform: scale(1.1);
          }
          100% {
            opacity: 1;
            transform: scale(1);
          }
        }
        .animate-fade-in-scale {
          animation: fade-in-scale 1.2s cubic-bezier(0.4,0,0.2,1) both;
        }
      `}</style>
    </section>
  );
}

export default HeroSection;
